// Language translations for Bitsy UI text
export const translations = {
  en: {
    // Main Menu
    welcomeTitle: "Welcome to Hodler Inn",
    railroadCrew: "Railroad Crew Check In Here",
    selectOption: "Select an option below to continue",
    checkIn: "Check In",
    checkOut: "Check Out",
    viewSignInSheet: "View Sign-In Sheet",
    howToUseHelp: "How to Use / Help",
    // Check-in form
    guestCheckIn: "Guest Check-In",
    employeeNumber: "Employee Number",
    tapToEnterNumber: "⬇️ TAP HERE to enter number",
    name: "Name",
    nameAutoAppear: "Name will appear automatically",
    welcome: "Welcome!",
    roomNumber: "Room Number",
    tapToEnterRoom: "⬇️ TAP HERE to enter room",
    date: "Date",
    time: "Time",
    signature: "Signature (sign below)",
    clear: "Clear",
    completeCheckIn: "Complete Check-In",
    processing: "Processing...",
    // Employee not found
    employeeIdNotFound: "Employee ID Not Found",
    notInSystem: "Your employee number is not in our system.",
    didYouMean: "Did you mean one of these?",
    tapCorrectNumber: "Tap the correct number above to use it",
    pleaseUseYellowCard: "Please Use Yellow Card",
    yellowCardInstructions: "Write your Name, Employee Number, Room Number and Time on the Yellow Card.",
    adminWillAdd: "Admin will check you in when they see it.",
    ifError: "If you believe this is an error, please contact the front desk or call the Help Phone.",
    // Check-out
    guestCheckOut: "Guest Check-Out",
    findMyBooking: "Find My Booking",
    findingBooking: "Finding booking...",
    bookingFound: "Booking Found",
    employeeId: "Employee ID",
    room: "Room",
    checkedIn: "Checked in",
    notYourBooking: "Not your booking? Try again",
    checkOutDate: "Check-Out Date",
    onDutyTime: "On Duty Time",
    completeCheckOut: "Complete Check-Out",
    // Success
    haveGoodRest: "Have a good rest 🌙",
    welcomeToHodlerInn: "Welcome to Hodler Inn",
    thankYouForStaying: "Thank you for staying at Hodler Inn",
    haveSafeJourney: "Have a safe journey! 🚂",
    keyReminder: "Please drop your room key in the Key Drop Box in the Lounge",
    returnToMenu: "Return to Menu",
    autoReturning: "Auto-returning in a few seconds...",
    // Greetings
    goodMorning: "Good morning",
    goodAfternoon: "Good afternoon",
    goodEvening: "Good evening",
    goodNight: "Good night",
    // Language
    language: "EN",
    back: "Back",
    backToMenu: "Back to Menu",
    // Bitsy Check-in
    quickCheckIn: "Quick Check-In",
    talkToBitsy: "Talk to Bitsy",
    orUseForm: "Or use form",
    typeMessage: "Type your message...",
    bitsySays: "Bitsy says:",
    signHere: "Please sign below",
    submitSignature: "Submit Signature",
  },
  es: {
    // Main Menu
    welcomeTitle: "Bienvenido a Hodler Inn",
    railroadCrew: "Registro de Tripulación Ferroviaria Aquí",
    selectOption: "Seleccione una opción para continuar",
    checkIn: "Registrarse",
    checkOut: "Salir",
    viewSignInSheet: "Ver Hoja de Registro",
    howToUseHelp: "Cómo Usar / Ayuda",
    // Check-in form
    guestCheckIn: "Registro de Huésped",
    employeeNumber: "Número de Empleado",
    tapToEnterNumber: "⬇️ TOQUE AQUÍ para ingresar número",
    name: "Nombre",
    nameAutoAppear: "El nombre aparecerá automáticamente",
    welcome: "¡Bienvenido!",
    roomNumber: "Número de Habitación",
    tapToEnterRoom: "⬇️ TOQUE AQUÍ para ingresar habitación",
    date: "Fecha",
    time: "Hora",
    signature: "Firma (firme abajo)",
    clear: "Borrar",
    completeCheckIn: "Completar Registro",
    processing: "Procesando...",
    // Employee not found
    employeeIdNotFound: "ID de Empleado No Encontrado",
    notInSystem: "Su número de empleado no está en nuestro sistema.",
    didYouMean: "¿Quiso decir uno de estos?",
    tapCorrectNumber: "Toque el número correcto arriba para usarlo",
    pleaseUseYellowCard: "Por Favor Use la Tarjeta Amarilla",
    yellowCardInstructions: "Escriba su Nombre, Número de Empleado, Número de Habitación y Hora en la Tarjeta Amarilla.",
    adminWillAdd: "El administrador lo registrará cuando lo vea.",
    ifError: "Si cree que esto es un error, por favor contacte a la recepción o llame al Teléfono de Ayuda.",
    // Check-out
    guestCheckOut: "Salida de Huésped",
    findMyBooking: "Buscar Mi Reserva",
    findingBooking: "Buscando reserva...",
    bookingFound: "Reserva Encontrada",
    employeeId: "ID de Empleado",
    room: "Habitación",
    checkedIn: "Registrado",
    notYourBooking: "¿No es su reserva? Intente de nuevo",
    checkOutDate: "Fecha de Salida",
    onDutyTime: "Hora de Servicio",
    completeCheckOut: "Completar Salida",
    // Success
    haveGoodRest: "Que descanse bien 🌙",
    welcomeToHodlerInn: "Bienvenido a Hodler Inn",
    thankYouForStaying: "Gracias por hospedarse en Hodler Inn",
    haveSafeJourney: "¡Buen viaje! 🚂",
    keyReminder: "Por favor deje su llave en la Caja de Llaves en el Salón",
    returnToMenu: "Volver al Menú",
    autoReturning: "Regresando automáticamente en unos segundos...",
    // Greetings
    goodMorning: "Buenos días",
    goodAfternoon: "Buenas tardes",
    goodEvening: "Buenas tardes",
    goodNight: "Buenas noches",
    // Language
    language: "ES",
    back: "Volver",
    backToMenu: "Volver al Menú",
    // Bitsy Check-in
    quickCheckIn: "Registro Rápido",
    talkToBitsy: "Hablar con Bitsy",
    orUseForm: "O usa el formulario",
    typeMessage: "Escribe tu mensaje...",
    bitsySays: "Bitsy dice:",
    signHere: "Por favor firme abajo",
    submitSignature: "Enviar Firma",
  }
};

// Get browser language preference
export const getBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  return browserLang.startsWith('es') ? 'es' : 'en';
};

// Get stored language or detect from browser
export const getInitialLanguage = () => {
  const stored = localStorage.getItem('bitsy_language');
  if (stored) return stored;
  return getBrowserLanguage();
};
